<div *ngIf="!init" style="align-self: center">
  <mat-spinner style="margin: auto" color="primary" diameter="24"></mat-spinner>
</div>
<div *ngIf="init" class="placer-project-container">
  <div class="button-container">
    <div class="action-buttons">
      <div class="navigation-link clickable action-button waze-link">
        <img
          src="../../../../../assets/waze-icon.png"
          width="30px"
          height="30px"
        />
        <a
          class="waze-link-margin"
          href="{{
            subProject.projectPlacement?.address?.line1
              | wazeLink
                : subProject.projectPlacement?.address?.city
                : subProject.projectPlacement?.address?.postalCode
                : subProject.projectPlacement?.address?.country
                : subProject.projectPlacement?.address?.coordinates?.lat
                : subProject.projectPlacement?.address?.coordinates?.lng
          }}"
          target="_blank"
          >Start navigatie</a
        >
      </div>

      <div class="placement-button">
        <button
          class="start-timer action-button clickable placement-button-height"
          [disabled]="placementStarted || disallowStartPlacement"
          [ngClass]="
            placementStarted || disallowStartPlacement
              ? 'start-timer-disabled'
              : ''
          "
          (click)="startPlacement()"
        >
          <div class="d-flex">
            <mat-icon
              [ngClass]="
                placementStarted
                  ? 'placement-started-schedule-icon'
                  : 'schedule-icon'
              "
              >schedule</mat-icon
            >
            <div
              class="start-text"
              [ngClass]="
                placementStarted
                  ? 'placement-started-text'
                  : 'placement-button-text'
              "
            >
              {{ placementStarted ? 'Uitvoering gestart' : 'Start plaatsing' }}
            </div>
          </div>
        </button>
      </div>
    </div>
    <span class="project-id align-right">#{{ project.id }}</span>
  </div>

  <div class="banner project-type-banner" [ngClass]="bannerClass">
    <div class="banner-text center-text">{{ bannerText }}</div>
  </div>

  <p *ngIf="timeBudget?.length > 0" class="strong center-text">
    Voorziene timing: {{ timeBudget }}
  </p>

  <div
    *ngIf="subProject.projectPlacement.appointment"
    class="banner appointment-banner"
  >
    <div class="banner-text center-text">
      <span class="strong">{{ appointmentText }}</span>
      <span
        *ngIf="subProject.projectPlacement.needAppointmentInfo?.length > 0"
        class="preserve-line-break"
        >{{ subProject.projectPlacement.needAppointmentInfo }}</span
      >
    </div>
  </div>

  <div class="form-title">
    <div class="form-title-text">{{ companyHeaderText }}</div>
  </div>

  <mat-card class="mat-elevation-z0 overflow-hidden vertically-center">
    <div
      *ngFor="
        let pcg of projectContactGroups;
        let first = first;
        let last = last
      "
    >
      <div [ngClass]="first ? '' : 'upper-space'" class="contact-group">
        <div *ngIf="pcg.contacts != null && pcg.contacts.length > 0">
          <div
            class="font-weight-bold click-link"
            (click)="openCompanyDisplayDialog(pcg.company)"
          >
            {{ pcg.company.regularName }}
          </div>
          <div *ngFor="let groupContact of pcg.contacts" class="d-flex">
            <div>
              <span *ngIf="groupContact.firstName"
                >{{ groupContact.firstName }}
              </span>
              <span *ngIf="groupContact.lastName">{{
                groupContact.lastName
              }}</span>
            </div>
            <div
              *ngFor="let phone of groupContact.telephones; let first = first"
            >
              <span>&nbsp;/&nbsp;</span>
              <a class="click-link" href="tel:{{ phone.number }}">
                {{ phone.number | asFormatPhoneNumber }}
              </a>
            </div>
            <div *ngFor="let email of groupContact.emails; let first = first">
              <span>&nbsp;/&nbsp;</span>
              <a
                class="click-link"
                href="{{
                  email.email
                    | mailSubjectBodyLink
                      : project.id
                      : groupContact.firstName
                      : subProject.projectPlacement?.address?.line1
                      : subProject.projectPlacement?.address?.postalCode
                      : subProject.projectPlacement?.address?.city
                }}"
              >
                {{ email.email }}
              </a>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            pcg.company.immoscoop || pcg.company.spotto || atLeastOneInpressLogo
          "
        >
          <img
            *ngIf="pcg.company.immoscoop"
            src="/assets/immoscoop_banner.png"
            class="immoscoop-logo"
          />
          <img
            *ngIf="pcg.company.spotto"
            src="/assets/spotto_banner.png"
            class="spotto-logo"
          />
          <img
            *ngIf="atLeastOneInpressLogo"
            src="/assets/logo.png"
            class="inpress-logo"
          />
        </div>
      </div>
    </div>
  </mat-card>

  <div *ngIf="subProject.type !== 'BaseProject'">
    <div class="info-banner" [ngClass]="bannerClass">
      <div class="project-type-banner banner-text info-banner-text">
        {{ adjustmentPlacementInfoTitle }}
      </div>
    </div>
    <mat-card class="mat-elevation-z0 overflow-hidden vertically-center">
      <div class="product-display">
        <div class="product-display-text">
          <div
            *ngIf="subProject.extraInfoAdjustment?.length > 0"
            class="under-space"
          >
            <span class="preserve-line-break">{{
              subProject.extraInfoAdjustment
            }}</span>
          </div>
          <div *ngIf="subProject.material?.length > 0">
            <span class="strong">Materiaal: </span>
            <span class="preserve-line-break">{{ subProject.material }}</span>
          </div>
          <div *ngIf="subProject.size?.length > 0">
            <span class="strong">Afmetingen: </span>
            <span class="preserve-line-break">{{ subProject.size }}</span>
          </div>
          <div *ngIf="subProject.amountDesign?.length > 0">
            <span class="strong">Aantal: </span>
            <span class="preserve-line-break">{{
              subProject.amountDesign
            }}</span>
          </div>
          <div *ngIf="subProject.store != null && showStoreQuestion">
            <span class="strong">Stockeren of weggooien: </span>
            <span>{{
              subProject.store
                | formatBoolean : false : 'Stockeren' : 'Weggooien'
            }}</span>
          </div>
        </div>
        <div class="product-display-execution-and-assets">
          <div class="product-display-execution">
            <div
              *ngIf="adjustmentExecutedString != null"
              class="executed-display d-flex"
            >
              <div class="executed-text">
                {{ adjustmentExecutedString
                }}<span
                  *ngIf="
                    displayTotalExecutionTime && totalExecutionTime?.length > 0
                  "
                  >{{ totalExecutionTime }}</span
                >
              </div>
              <mat-icon svgIcon="{{ adjustmentExecutedIcon }}"></mat-icon>
            </div>
          </div>
          <ng-container *ngIf="adjustmentPhotos?.length === 1">
            <div
              class="single-design-photo"
              [ngClass]="adjustmentExecutedString != null ? 'upper-space' : ''"
            >
              <img
                class="max-asset-width max-asset-height clickable"
                src="{{ adjustmentPhotos[0].preview }}"
                (click)="openAlbumLightbox(adjustmentPhotos, index)"
              />
            </div>
          </ng-container>
          <ng-container *ngIf="adjustmentPhotos?.length > 1">
            <div
              class="design-photo-grid"
              [ngClass]="adjustmentExecutedString != null ? 'upper-space' : ''"
            >
              <img
                *ngFor="let asset of adjustmentPhotos; let index = index"
                class="max-asset-width max-asset-height clickable"
                src="{{ asset.preview }}"
                (click)="openAlbumLightbox(adjustmentPhotos, index)"
              />
            </div>
          </ng-container>
        </div>
      </div>
    </mat-card>
  </div>

  <div class="form-title">
    <div class="form-title-text">
      Product info
      <span *ngIf="subProject?.type === 'Adjustment'"
        >(initiële plaatsing)</span
      >
    </div>
  </div>

  <mat-card
    *ngFor="
      let product of productDisplays;
      let index = index;
      trackBy: trackById
    "
    class="mat-elevation-z0 overflow-hidden vertically-center"
  >
    <div class="product-display">
      <div class="product-display-text">
        <div class="placer-card-header">
          {{ product.productType }}
          <span class="product-number">#{{ index + 1 }}</span>
        </div>
        <div>
          <span class="strong">Type: </span>
          <span>{{ product.productType }}</span>
        </div>
        <div
          *ngIf="
            product.materialLine != null && product.materialLine.length > 0
          "
        >
          <span class="strong">Materiaal: </span
          ><span>{{ product.materialLine }}</span>
        </div>
        <div *ngFor="let subProductDisplay of product.subProductDisplays">
          <ng-container *ngIf="subProductDisplay.line.length > 0">
            <span class="strong">{{ subProductDisplay.header }} </span>
            <span>{{ subProductDisplay.line }}</span>
          </ng-container>
        </div>
        <div *ngIf="product.boardTilingLine?.length > 0">
          <span class="strong">Tiling formaten: </span>
          <span class="preserve-line-break">{{ product.boardTilingLine }}</span>
        </div>
        <ng-container
          *ngIf="
            product.title?.length > 0 ||
            product.text?.length > 0 ||
            product.productPhoneNumbers?.length > 0
          "
        >
          <div class="small-upper-space">
            <div *ngIf="product.title?.length > 0">
              <span class="strong">Titel: </span>
              <span>{{ product.title }}</span>
            </div>
            <div *ngIf="product.text?.length > 0">
              <span class="strong">Tekst: </span>
              <span class="preserve-line-break">{{ product.text }}</span>
            </div>
            <div *ngIf="product.productPhoneNumbers?.length > 0" class="d-flex">
              <span class="strong">Tel:&nbsp;</span>
              <span
                *ngFor="
                  let phone of product.productPhoneNumbers;
                  let first = first
                "
              >
                <span *ngIf="!first">&nbsp;/&nbsp;</span>
                <a class="click-link" href="tel:{{ phone }}">{{ phone }}</a>
              </span>
            </div>
          </div>
        </ng-container>
        <div *ngIf="product?.immoscoopLogo != null">
          <img
            src="/assets/{{
              product.immoscoopLogo
                ? 'immoscoop_banner'
                : 'immoscoop_banner_kruis'
            }}.png"
            class="immoscoop-logo"
          />
        </div>
        <div *ngIf="product?.spottoLogo != null">
          <img
            src="/assets/{{
              product.spottoLogo ? 'spotto_banner' : 'spotto_banner_kruis'
            }}.png"
            class="spotto-logo"
          />
        </div>
      </div>
      <div class="product-display-execution-and-assets">
        <div *ngIf="subProject?.type === 'BaseProject'">
          <div class="d-flex">
            <div
              *ngIf="product?.productTypeValue === productTypes.BOARD.value"
              class="d-flex"
            >
              <button
                mat-button
                type="button"
                class="button construction-materials-button"
                (click)="openConstructionMaterialsModal(index)"
              >
                Constructiematerialen
              </button>
              <img
                *ngIf="product.sketchUpAlbum?.length > 0"
                class="sketch-up-button"
                [src]="'/assets/sketchup-square.svg'"
                height="36"
                (click)="openAlbumLightbox(product.sketchUpAlbum)"
              />
            </div>
            <div class="placement-type-container">
              <span class="placement-type" [ngClass]="product.executedClass"
                >Plaatsing</span
              >
            </div>
          </div>
          <div
            *ngIf="product?.executedString != null"
            class="executed-text-margin executed-display d-flex"
          >
            <div class="executed-text">
              {{ product.executedString
              }}<span
                *ngIf="
                  subProject?.type === 'BaseProject' &&
                  displayTotalExecutionTime &&
                  totalExecutionTime?.length > 0
                "
                >{{ totalExecutionTime }}</span
              >
            </div>
            <mat-icon svgIcon="{{ product.executedIcon }}"></mat-icon>
          </div>
        </div>
        <div class="design-photo-grid photo-margin">
          <img
            *ngFor="let asset of product.album; let index = index"
            class="max-asset-width max-asset-height clickable"
            src="{{ asset.preview }}"
            (click)="openAlbumLightbox(product.album, index)"
          />
        </div>
      </div>
    </div>
  </mat-card>

  <div class="form-title">
    <div class="form-title-text">Plaatsingsinfo</div>
  </div>

  <mat-card class="mat-elevation-z0 overflow-hidden vertically-center">
    <div class="product-display">
      <div class="product-display-text">
        <ng-container *ngIf="!projectPlacementAddressEmpty">
          <div>
            <span class="strong">Adres: </span>
            <span>{{
              subProject.projectPlacement.address.line1
                | printAddress
                  : subProject.projectPlacement.address.postalCode
                  : subProject.projectPlacement.address.city
            }}</span>
          </div>
          <div>
            <span class="strong">Enkele rit: </span>
            <span
              >{{
                baseProject.projectPlacement.kilometersTo
                  | asFormatDecimal : false : 2
                  | or
              }}
              km</span
            >
          </div>
        </ng-container>
        <div *ngIf="extraInfoAddress?.length > 0">
          <span class="strong">Extra info adres: </span>
          <span class="preserve-line-break">{{ extraInfoAddress }}</span>
        </div>
        <div *ngIf="extraPlacementInfo?.length > 0">
          <span class="strong">Info klant omtrent plaatsing: </span>
          <span class="preserve-line-break">{{ extraPlacementInfo }}</span>
        </div>
        <div *ngIf="subProject.projectPlacement.undergroundPipework">
          <span class="strong">Ondergrondse leidingen: </span>
          <span class="preserve-line-break">{{
            subProject.projectPlacement.undergroundPipeworkText | or : 'Ja'
          }}</span>
        </div>
      </div>

      <div class="product-display-execution-and-assets">
        <ng-container *ngIf="sitePhotos?.length > 0">
          <ng-container
            *ngIf="subProject?.type === 'Adjustment'; else noAdjustment"
          >
            <div class="single-design-photo photo-margin">
              <img
                class="max-asset-width max-asset-height clickable"
                src="{{ sitePhotos[sitePhotos?.length - 1].preview }}"
                (click)="openAlbumLightbox(sitePhotos, sitePhotos?.length - 1)"
              />
            </div>
          </ng-container>
          <ng-template #noAdjustment>
            <div class="design-photo-grid photo-margin">
              <img
                *ngFor="let asset of sitePhotos; let index = index"
                class="max-asset-width max-asset-height clickable"
                src="{{ asset?.preview }}"
                (click)="openSitePhotosLightbox(index)"
              />
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="subProject?.type === 'BaseProject'">
      <div *ngFor="let product of productDisplays; let index = index">
        <div
          class="strong details-title-margin"
          [ngClass]="index === 0 ? 'upper-space' : ''"
        >
          Details{{
            productDisplays.length === 1
              ? ''
              : ' ' + product.productType + ' #' + (index + 1)
          }}:
        </div>
        <ul class="inpress-ul">
          <li *ngIf="placementFloor != null">
            <span class="preserve-line-break display-contents">
              <span class="strong inline-flex">Verdieping: </span>
              {{ placementFloor }}
            </span>
          </li>
          <li *ngIf="product.alignStickerLine?.length > 0">
            <span class="preserve-line-break display-contents">
              <span class="strong inline-flex">Uitlijnen sticker: </span>
              {{ product.alignStickerLine }}
            </span>
          </li>
          <li *ngIf="product.boardPlaceInstructionsLine?.length > 0">
            <span class="preserve-line-break display-contents">
              <span class="strong inline-flex">Hoe plaatsen: </span>
              {{ product.boardPlaceInstructionsLine }}
            </span>
          </li>
          <li *ngIf="product.boardDistanceFrontPostLine?.length > 0">
            <span class="preserve-line-break display-contents">
              <span class="strong inline-flex"
                >Afstand voorste paal tot straat:
              </span>
              {{ product.boardDistanceFrontPostLine }}
            </span>
          </li>
          <li *ngIf="product.newWoodPosts?.length > 0">
            <span class="strong">Nieuw hout of recup hout: </span>
            <span>{{ product.newWoodPosts }}</span>
          </li>
          <li *ngIf="product.obstaclesLine?.length > 0">
            <span class="preserve-line-break display-contents">
              <span class="strong inline-flex">Obstakels: </span>
              {{ product.obstaclesLine }}
            </span>
          </li>
          <li *ngIf="product.oldStickersLine?.length > 0">
            <span class="preserve-line-break display-contents">
              <span class="strong inline-flex">Oude stickers: </span>
              {{ product.oldStickersLine }}
            </span>
          </li>
          <li *ngIf="product.dryWetInsideOutside?.length > 0">
            <span class="strong">Kleefinstructies: </span>
            <span class="preserve-line-break">{{
              product.dryWetInsideOutside
            }}</span>
          </li>
        </ul>
        <ng-container *ngIf="product.installerInfo?.length > 0">
          <div class="strong">
            Info installateur{{
              productDisplays.length === 1
                ? ''
                : ' ' + product.productType + ' #' + (index + 1)
            }}:
          </div>
          <div class="preserve-line-break under-space">
            {{ product.installerInfo }}
          </div>
        </ng-container>
      </div>

      <div *ngIf="heightEquipmentLine?.length > 0" class="upper-space">
        <div class="strong">Ladder/stelling/hoogwerker:</div>
        <div>{{ heightEquipmentLine }}</div>
      </div>

      <div *ngIf="extraInfoSite?.length > 0" class="upper-space">
        <div class="strong">Extra info locatie:</div>
        <div class="preserve-line-break">
          <span>{{ extraInfoSite }}</span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="subProject.type !== 'BaseProject'">
      <div class="strong upper-space details-title-margin">Details:</div>
      <ul class="inpress-ul">
        <li *ngIf="placementFloor != null">
          <span class="strong">Verdieping: </span>
          <span>{{ placementFloor }}</span>
        </li>
        <li *ngIf="heightEquipmentLine?.length > 0">
          <span class="strong">Ladder/stelling/hoogwerker: </span>
          <span>{{ heightEquipmentLine }}</span>
        </li>
        <ng-container *ngFor="let product of productDisplays">
          <li *ngIf="product.obstaclesLine?.length > 0">
            <span class="preserve-line-break">{{ product.obstaclesLine }}</span>
          </li>
        </ng-container>
      </ul>

      <mat-card
        *ngIf="extraPlacementInfo?.length > 0"
        class="internal-form mat-elevation-z0 no-top-margin"
      >
        <div class="strong">Extra info installateur:</div>
        <div class="preserve-line-break">{{ extraPlacementInfo }}</div>
      </mat-card>
    </ng-container>
  </mat-card>

  <ng-container *ngIf="showExtraSupplier">
    <div class="form-title">
      <div class="form-title-text">Externe leveranciers</div>
    </div>

    <mat-card class="mat-elevation-z0 overflow-hidden vertically-center">
      <div *ngFor="let product of productDisplays; let index = index">
        <div
          *ngIf="product.extraHoogwerkerDescription?.length > 0"
          class="upper-space"
        >
          <div class="strong">
            Hoogwerker{{
              productDisplays.length === 1
                ? ''
                : ' ' + product.productType + ' #' + (index + 1)
            }}:
          </div>
          <div class="preserve-line-break">
            {{ product.extraHoogwerkerDescription }}
          </div>
        </div>
        <div
          *ngIf="product.extraInfoParkingBan?.length > 0"
          class="upper-space"
        >
          <div class="strong">
            Parkeerverbod{{
              productDisplays.length === 1
                ? ''
                : ' ' + product.productType + ' #' + (index + 1)
            }}:
          </div>
          <div class="preserve-line-break">
            {{ product.extraInfoParkingBan }}
          </div>
        </div>
        <div
          *ngIf="product.extraInfoNeedExtraSupplier?.length > 0"
          class="upper-space"
        >
          <div class="strong">
            Extra leverancier{{
              productDisplays.length === 1
                ? ''
                : ' ' + product.productType + ' #' + (index + 1)
            }}:
          </div>
          <div class="preserve-line-break">
            {{ product.extraInfoNeedExtraSupplier }}
          </div>
        </div>
      </div>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="showExtraMaterials">
    <div class="form-title" [ngClass]="showExtraSupplier ? 'upper-space' : ''">
      <div class="form-title-text">Extra materialen</div>
    </div>
    <mat-card class="internal-form mat-elevation-z0 no-top-margin">
      <div
        *ngFor="let product of productDisplays; let index = index"
        [ngClass]="productDisplays.length > 1 ? 'upper-space' : ''"
      >
        <div *ngIf="product.extraInfoNeedExtraMaterials?.length > 0">
          <div *ngIf="productDisplays.length > 1" class="strong">
            {{ product.productType + ' #' + (index + 1) }}:
          </div>
          <div class="preserve-line-break">
            {{ product.extraInfoNeedExtraMaterials }}
          </div>
        </div>
      </div>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="showExternalSupplierAdjustment">
    <div class="form-title">
      <div class="form-title-text">Externe leveranciers</div>
    </div>

    <mat-card class="mat-elevation-z0 overflow-hidden vertically-center">
      <div *ngIf="extraHoogwerkerAdjustment?.length > 0" class="upper-space">
        <div class="strong">Hoogwerker:</div>
        <div class="preserve-line-break">
          {{ extraHoogwerkerAdjustment }}
        </div>
      </div>
      <div *ngIf="parkingBanAdjustment?.length > 0" class="upper-space">
        <div class="strong">Parkeerverbod:</div>
        <div class="preserve-line-break">
          {{ parkingBanAdjustment }}
        </div>
      </div>
      <div *ngIf="extraSupplierAdjustment?.length > 0" class="upper-space">
        <div class="strong">Extra leverancier:</div>
        <div class="preserve-line-break">
          {{ extraSupplierAdjustment }}
        </div>
      </div>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="subProject.needExtraMaterials">
    <div
      class="form-title"
      [ngClass]="showExternalSupplierAdjustment ? 'upper-space' : ''"
    >
      <div class="form-title-text">Extra materialen</div>
    </div>
    <mat-card class="internal-form mat-elevation-z0 no-top-margin">
      <div class="preserve-line-break">
        {{ extraMaterialsAdjustment }}
      </div>
    </mat-card>
  </ng-container>

  <div class="form-title upper-space">
    <div class="form-title-text">Opmerkingen</div>
  </div>

  <div *ngIf="subProject.type === 'BaseProject'">
    <mat-card
      *ngFor="
        let product of project.products;
        let index = index;
        trackBy: trackById
      "
      class="mat-elevation-z0 overflow-hidden vertically-center"
    >
      <div class="placer-card-header">
        {{ product.type | productType : product.otherProductName }}
        <span class="product-number">#{{ index + 1 }}</span>
      </div>
      <div
        *ngIf="
          product.type === 'WindowSticker' ||
          product.type === 'CustomWindowSticker'
        "
        class="notes-row"
      >
        <div class="notes-row-label">Beschadiging aan ramen:</div>
        <div class="notes-row-content">
          <div class="align-text-area">
            <textarea-input
              [client]="true"
              [initContent]="product.productPlacement?.extraInfoVisibleDamage"
              [placeholder]="'Is er schade aan de ramen?'"
              [disabled]="!placementStarted"
              (answer)="visibleDamageChange($event, index)"
            ></textarea-input>
          </div>
        </div>
      </div>
      <div class="notes-row">
        <div class="notes-row-label">Feedback installateur:</div>
        <div class="notes-row-content">
          <div class="align-text-area">
            <textarea-input
              [client]="true"
              [initContent]="product.productPlacement?.installerFeedback"
              [placeholder]="
                'Verplicht als de plaatsing niet is kunnen doorgaan.'
              "
              [disabled]="!placementStarted"
              (answer)="installerFeedbackChange($event, index)"
            ></textarea-input>
          </div>
        </div>
      </div>
      <div class="notes-row">
        <div class="notes-row-label">Foto toevoegen</div>
        <div class="notes-row-content">
          <div class="align-file-picker">
            <file-picker
              [formSection]="'execution'"
              [inputProduct]="product"
              [uploadButtonLabel]="'Toevoegen'"
              [noLeftSpace]="true"
              [disabled]="!placementStarted"
              [offlineUpload]="true"
              [disabledErrorMessage]="'Gelieve de plaatsing eerst te starten'"
              (answer)="productAssetStored(index)"
              (assetDeleted)="productAssetDeleted(index)"
            ></file-picker>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <div *ngIf="subProject.type !== 'BaseProject'">
    <mat-card class="mat-elevation-z0 overflow-hidden vertically-center">
      <div class="notes-row">
        <div class="notes-row-label">Feedback installateur:</div>
        <div class="notes-row-content">
          <div class="align-text-area">
            <textarea-input
              [client]="true"
              [initContent]="subProject.projectPlacement?.placerFeedback"
              [placeholder]="
                'Verplicht als de plaatsing niet is kunnen doorgaan.'
              "
              [disabled]="!placementStarted"
              (answer)="placerFeedbackChange($event)"
            ></textarea-input>
          </div>
        </div>
      </div>
      <div class="notes-row">
        <div class="notes-row-label">Foto toevoegen</div>
        <div class="notes-row-content">
          <div class="align-file-picker">
            <file-picker
              [formSection]="'adjustmentPlacementSuccess'"
              [inputProjectPlacement]="subProject.projectPlacement"
              [uploadButtonLabel]="'Toevoegen'"
              [noLeftSpace]="true"
              [disabled]="!placementStarted"
              [offlineUpload]="true"
              [disabledErrorMessage]="'Gelieve de plaatsing eerst te starten'"
              (answer)="projectAssetStored()"
              (assetDeleted)="projectAssetDeleted()"
            ></file-picker>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <div class="float-right">
    <div class="d-flex">
      <ng-container *ngIf="submitInProgress || submitQueued">
        <button
          *ngIf="submitQueued && !submitInProgress"
          mat-button
          class="button executed-button"
          [disabled]="submitting"
          (click)="retrySubmit()"
        >
          Manueel opnieuw proberen
        </button>
        <div
          *ngIf="submitQueued && !submitInProgress"
          matTooltip="Project staat klaar om ingediend te worden"
        >
          <mat-icon class="queue-icon">cloud_queue</mat-icon>
        </div>
        <div *ngIf="submitInProgress" matTooltip="Project wordt ingediend">
          <mat-spinner
            class="submitting-icon"
            color="primary"
            diameter="30"
          ></mat-spinner>
        </div>
      </ng-container>
      <button
        mat-button
        class="button not-executed-button"
        [disabled]="
          !allowNotExecuted ||
          submitting ||
          !placementStarted ||
          storingOfflineChange
        "
        (click)="submitNotExecuted()"
      >
        Niet uitgevoerd
      </button>
      <button
        mat-button
        class="button executed-button button-left-space"
        [disabled]="
          !allowExecuted ||
          submitting ||
          !placementStarted ||
          storingOfflineChange
        "
        (click)="submitExecuted()"
      >
        Uitgevoerd
      </button>
    </div>
  </div>
</div>
